module.exports = __webpack_public_path__ + "img/Faint Engraving.3d1257bb.png";